import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { ClipPath, Defs, G, Path, Rect } from "react-native-svg";

export const IconFormSeal: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFormSeal"><G ClipPath="url(#clip0_14456_27922)"><Path d="M19.5 4.5H15L12 1.5L9 4.5H4.5V9L1.5 12L4.5 15V19.4849H9L12 22.5L15 19.4849H19.5V15L22.5 12L19.5 9V4.5Z" stroke="currentColor"/></G><Defs><ClipPath id="clip0_14456_27922"><Rect width="24" height="24" fill="white"/></ClipPath></Defs></CentralIconBase>;
});

export default IconFormSeal;
